<template>
  <div class="page page__has-bar">
    <div class="page__bd">
      <div class="weui-cells__group textarea-cell">
        <div class="weui-cells__title">反馈内容</div>
        <div class="weui-cells">
          <div class="weui-cell">
            <div class="weui-cell__bd">
              <textarea
                class="weui-textarea"
                placeholder="说说你的问题"
                rows="8"
                v-model="form.main.fb_msg"
                maxlength="500"
              ></textarea>
              <div class="weui-textarea-counter">
                <span>{{form.main.fb_msg?form.main.fb_msg.length:0}}</span>/500
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="footer-bar weui-dialog__ft">
      <a href="javascript:;" class="weui-dialog__btn weui-dialog__btn_primary" @click="save">提交</a>
      <a
        href="javascript:;"
        class="weui-dialog__btn weui-dialog__btn_default"
        @click="$router.back()"
      >取消</a>
    </div>
  </div>
</template>

<script>
import form from "@/mixins/form.js";

export default {
  mixins: [form],
  data() {
    return {
      baseUrl: "/api/commons/feedBack"
    };
  },
  methods: {
    save() {
      var me = this,
        main = me.form.main;
      if (!main.fb_msg) {
        me.$weui.topTips("请填写反馈内容", 2000);
      } else {
        me.f_save(function() {
          me.$router.back();
        });
      }
    }
  }
};
</script>